import { Injectable } from '@angular/core';
import { SESSION_EXPIRED_MSG } from '@shared/constant/shared.constant';
import { EncryptionStorageService } from './encryption-storage.service';
@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private sessionExpiredHandled = false;

  constructor(private readonly encryptStorage: EncryptionStorageService) {}

  getToken(): string {
    const token = this.encryptStorage.getItem('token');
    return token ? token : "";
  }
  setToken(token: string): void {
    this.encryptStorage.setItem('token', token);

  }
  setUserId(userId: string): void {
    this.encryptStorage.setItem('id', userId);

  }
  getUserId(): string {
    const userId = this.encryptStorage.getItem('id');
    return userId ? userId : "";

  }
  isLoggedIn(): boolean {
    const token = this.getToken();
    return token ? true : false;
  }
  handleSessionExpiry(toastService) {
    if (!this.sessionExpiredHandled) {
      this.sessionExpiredHandled = true;
      toastService.showToastMessage( 'error','Error', SESSION_EXPIRED_MSG );
      localStorage.removeItem('token');
      setTimeout(() => {
        window.location.href = '/login';
        this.sessionExpiredHandled = false;
      }, 3000);
    }
  }
}
